import $ from "jquery";
import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation } from "swiper/modules";

window.$ = window.jQuery = $;

$(function initSoramachiHeader() {
  const $header = $("[data-soramachi-header]");

  if ($header.length === 0) return;

  const $drawer = $header.find("[data-soramachi-drawer]");
  const $openButton = $header.find("[data-soramachi-drawer-open]");
  const openClass = "is-open";
  const headerOpenClass = "is-drawer-open";
  const bodyClass = "is-locked";
  const focusableSelector = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])',
  ].join(", ");

  let lastFocusedElement = null;

  const getFocusableElements = () => $drawer.find(focusableSelector).filter(":visible").toArray();

  const focusInitialElement = () => {
    const focusableElements = getFocusableElements();

    if (focusableElements.length > 0) {
      focusableElements[0].focus();
      return;
    }

    if ($openButton.length > 0) {
      $openButton[0].focus();
    }
  };

  const restoreFocus = () => {
    if (lastFocusedElement instanceof HTMLElement && document.contains(lastFocusedElement)) {
      lastFocusedElement.focus();
    }
  };

  const setDrawerState = (isOpen) => {
    $drawer.toggleClass(openClass, isOpen);
    $header.toggleClass(headerOpenClass, isOpen);
    $drawer.attr("aria-hidden", isOpen ? "false" : "true");
    $openButton.attr("aria-expanded", isOpen ? "true" : "false");
    $("body").toggleClass(bodyClass, isOpen);

    if (isOpen) {
      window.requestAnimationFrame(focusInitialElement);
    } else {
      restoreFocus();
      lastFocusedElement = null;
    }
  };

  const closeDrawer = () => setDrawerState(false);
  const toggleDrawer = () => {
    if ($drawer.hasClass(openClass)) {
      closeDrawer();
      return;
    }

    lastFocusedElement = document.activeElement;
    setDrawerState(true);
  };

  $openButton.on("click", (event) => {
    event.preventDefault();
    toggleDrawer();
  });

  $drawer.on("click", (event) => {
    if (event.target === event.currentTarget) closeDrawer();
  });

  $(document).on("keydown", (event) => {
    if (!$drawer.hasClass(openClass)) return;

    if (event.key === "Escape") {
      closeDrawer();
      return;
    }

    if (event.key !== "Tab") return;

    const focusableElements = getFocusableElements();
    if (focusableElements.length === 0) {
      event.preventDefault();
      $openButton.trigger("focus");
      return;
    }

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    const activeElement = document.activeElement;

    if (event.shiftKey && activeElement === firstFocusable) {
      event.preventDefault();
      lastFocusable.focus();
      return;
    }

    if (!event.shiftKey && activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  });

  $(window).on("resize", () => {
    if (window.innerWidth >= 1120 && $drawer.hasClass(openClass)) {
      closeDrawer();
    }
  });
});

$(function initSoramachiHero() {
  const $heroes = $("[data-soramachi-hero]");

  if ($heroes.length === 0) return;

  $heroes.each((_, element) => {
    const $hero = $(element);
    const swiperElement = $hero.find(".c-hero__slides")[0];
    const previousButton = $hero.find("[data-soramachi-hero-prev]")[0];
    const nextButton = $hero.find("[data-soramachi-hero-next]")[0];

    if (!swiperElement || !previousButton || !nextButton) return;

    const swiper = new Swiper(swiperElement, {
      modules: [Autoplay, EffectFade, Navigation],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: false,
      rewind: true,
      speed: 800,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: previousButton,
      },
    });

    $hero.on("focusin", () => swiper.autoplay.stop());
    $hero.on("focusout", (event) => {
      if (!$hero[0].contains(event.relatedTarget)) swiper.autoplay.start();
    });
  });
});

$(function initSoramachiCategories() {
  const $categories = $("[data-soramachi-categories]");

  if ($categories.length === 0) return;

  $categories.on("change", "[data-soramachi-categories-select]", (event) => {
    const value = event.currentTarget.value;

    if (value) window.location.href = value;
  });
});

$(function initSoramachiContactCategory() {
  const $select = $("#contact-category");

  if ($select.length === 0) return;

  const url = new URL(window.location.href);
  const rawCategory = url.searchParams.get("category");

  const categoryMap = {
    事業について: "事業について問い合わせ",
    観光情報について: "観光情報について問い合わせ",
    パートナーについて: "パートナーについて問い合わせ",
  };

  const category = categoryMap[rawCategory] || rawCategory;

  if (!category) return;

  const $matchedOption = $select.find("option").filter((_, option) => option.value === category);

  if ($matchedOption.length === 0) return;

  $select.val(category);
});
